import { BaseResponseType } from '../cognito/authResponse.types';

export interface RestaurantsType {
  id: number;
  name: string;
}
export interface BusinessType {
  id?: string | number;
  businessName?: string;
  businessSince?: Date;
  taxId?: string;
  businessType?: string;
  address?: string;
  suite?: string;
  zipCode?: string;
  restaurants?: RestaurantsType[];
  ownerInfo?: any;
  businessAlias?: string;
  FEIN?: string;
}
export interface GetBusinessResponseType extends BaseResponseType {
  data: BusinessType | null;
}

export interface IBusiness {
  id?: number;
  businessName: string;
  businessSince: Date;
  taxId?: string;
  businessType: string | undefined;
  address: string;
  suite?: string;
  zipCode: string;
  contactNo: string;
  city: string;
  state: string;
  FEIN?: string;
  logo?: string | null;
  ownerInfo?: IOwnerInfo;
  stateIso?: string;
  companyId?: string;
  businessAlias?: string;
}
export interface IOwnerInfo {
  ownerName: string;
  ownerEmail: string;
  ownerContactNo: string;
}
export interface PocDetail {
  name: string;
  contactNo: string;
  roleId: number;
  email: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface ICreateBusinessInfo {
  businessInfo: IBusiness;
  pocInfo: PocDetail[];
}

export enum CompanyLinkPurpose {
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  ONBOARD = 'ONBOARD',
  PREVIOUS_PROVIDER_ACCESS = 'PREVIOUS_PROVIDER_ACCESS',
  FILING_PREPARATION = 'FILING_PREPARATION',
  FILING_PREVIEW = 'FILING_PREVIEW',
}
